import { render, staticRenderFns } from "./InWayOrders.vue?vue&type=template&id=334df93c&"
import script from "./InWayOrders.vue?vue&type=script&lang=js&"
export * from "./InWayOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports